import React from 'react';
import './UserBrief.scss';

interface UserBriefProps {
  firstName: string;
  lastName: string;
}

export const UserBrief: React.FC<UserBriefProps> = ({ firstName, lastName }) => {
  return (
    <div className="user-brief">
      <div className="avatar">
        <span>
          {firstName[0]}
          {lastName[0]}
        </span>
      </div>
      <div className="user-name">
        {firstName} {lastName}
      </div>
    </div>
  );
};
